var map = {
	"./plugins": "./src/plugins/index.js",
	"./plugins/": "./src/plugins/index.js",
	"./plugins/index": "./src/plugins/index.js",
	"./plugins/index.js": "./src/plugins/index.js",
	"./plugins/lodash": "./src/plugins/lodash.js",
	"./plugins/lodash.js": "./src/plugins/lodash.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src sync recursive ^\\.\\/plugins.*$";